/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleRegular from './chat-bubble-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatBubbleRegular {...validProps} />;
}

SvgComponent.iconName = 'chatBubbleRegular';

export const ChatBubbleRegularIcon = svgIconWrapper(SvgComponent);
